/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSVorleistungArt {
    HAGELVERSICHERUNG = <any> 'HAGELVERSICHERUNG',
    GEBAEUDEVERSICHERUNG = <any> 'GEBAEUDEVERSICHERUNG',
    PRIVATVERSICHERUNG = <any> 'PRIVATVERSICHERUNG',
    SUBVENTION = <any> 'SUBVENTION',
    SPENDE = <any> 'SPENDE',
    ANDERE = <any> 'ANDERE',


}

export function getTSVorleistungArten(): Array<TSVorleistungArt> {
    return [
        TSVorleistungArt.HAGELVERSICHERUNG,
        TSVorleistungArt.GEBAEUDEVERSICHERUNG,
        TSVorleistungArt.PRIVATVERSICHERUNG,
        TSVorleistungArt.SUBVENTION,
        TSVorleistungArt.SPENDE,
        TSVorleistungArt.ANDERE

    ];
}
export function vorleistungArtPrefix(): string {
    return 'TSVorleistungArt_';
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSVorleistungArt.ts